


















import Vue from 'vue';
import BbTools from '@/tools/bluebird';

export default Vue.extend({
  data() {
    return {
      deleteDialog: false,
    };
  },
  methods: {
    onAndroidApp(): void {
      window.open(BbTools.APP_LINK_ANDROID, '_blank');
    },
    onIOSApp(): void {
      window.open(BbTools.APP_LINK_IOS, '_blank');
    },
  },
});
